

























import mixins from 'vue-typed-mixins'
import InputValueWidth from '@/abstract/InputValueWidth'
import Icon from '@/components/Icon/Icon.vue'

interface Data {
  isEditMode: boolean
  saveInProgress: boolean
  inputValue: string
}

interface Methods {
  handleBlur: () => Promise<void>
  handleToggleEdit: (e: Event) => void
}

interface Computed {
  isShowInput: boolean
  icon: string
  inputWidth: string
  errorClass: string
  animationClass: string
}

interface Props {
  value: string
  editable: boolean
  maxlength: number
}

export interface OnSendData {
  value: string
  resolve: () => void
  reject: () => void
}

export default mixins(InputValueWidth).extend<Data, Methods, Computed, Props>({
  components: {
    Icon,
  },
  props: {
    value: {
      required: true,
      default: (): string => '',
    },
    editable: {
      default: (): boolean => true,
    },
    maxlength: {
      default: (): number | undefined => undefined,
    },
  },
  data: function() {
    return {
      isEditMode: false,
      saveInProgress: false,
      inputValue: this.value,
    }
  },
  computed: {
    isShowInput(): boolean {
      return this.editable && this.isEditMode
    },
    icon(): string {
      if (this.saveInProgress) {
        return 'zmdi-save'
      }
      return this.isEditMode ? 'zmdi-check' : 'zmdi-edit'
    },
    inputWidth(): string {
      const el = this.$refs.textEditor as HTMLElement
      return this.getInputWidth(this.inputValue, el, '0.875rem')
    },
    errorClass(): string {
      return !this.inputValue ? 'error' : ''
    },
    animationClass(): string {
      return this.saveInProgress ? 'blink' : ''
    },
  },
  methods: {
    handleToggleEdit(e: Event) {
      e.stopPropagation()
      if (!this.editable || this.saveInProgress) {
        return
      }

      this.isEditMode = !this.isEditMode

      if (this.isEditMode) {
        this.$nextTick(() => {
          this.inputValue = this.value
          ;(this.$refs.input as HTMLElement).focus()
        })
      }
    },
    async handleBlur() {
      if (
        !this.inputValue ||
        !this.editable ||
        this.saveInProgress ||
        this.inputValue === this.value
      ) {
        return
      }
      this.saveInProgress = true
      const onSendData: OnSendData = {
        value: this.inputValue,
        resolve: () => {
          this.saveInProgress = false
        },
        reject: () => {
          this.saveInProgress = false
          this.isEditMode = false
        },
      }
      this.$emit('on-send', onSendData)
    },
  },
  watch: {
    value() {
      if (this.isEditMode) {
        this.isEditMode = false
      }
    },
  },
})
